import { Component, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  standalone: false,
  selector: 'app-delete-popup',
  templateUrl: './delete-popup.component.html',
  styleUrl: './delete-popup.component.scss',
})
export class DeletePopupComponent {
  title;
  extra;
  text;
  id;
  @Input() onButtonClick!: (id) => Promise<void>;

  constructor(public bsModalRef: BsModalRef) {}

  closeModal() {
    this.bsModalRef.hide();
  }

  async buttonClicked() {
    if (this.onButtonClick) {
      await this.onButtonClick(this.id);
    }
    this.closeModal();
  }
}
